import usePage from '../../hooks/usePage';
import { getComponentFromName } from '../../lib/utils';

import { useTheme } from '../../contexts/ThemeContext';
import DefaultComponent from './AccountDefault';
import * as Components from './accounts';

function AccountPage(props) {
    const { name } = useTheme();
    const { page } = usePage();
    const Component = getComponentFromName(Components, name, DefaultComponent) || null;
    return Component !== null ? <Component {...props} page={page} /> : null;
}

export default AccountPage;
